<div class="wrapper">
  <header class="main-title">
    <section class="text-center container">
      <div class="container-header">
        <div class="row">
          <div class="col-12 col-md-5 col-logo order-md-2">
            <div class="div-logo">
              <img src="./assets/images/logo.svg" class="logo" alt="unesp">
            </div>
            <div class="unesp-titulo">
              <p i18n="@@slogan">É PÚBLICA. É MÚLTIPLA. É PARA TODOS.</p>
            </div>
          </div>
          <div class="col-12 col-md-7 col-titulo order-md-1">
            <div class="div-titulo">
              <h1 class="h1-titulo"><span i18n="@@programas_de">PROGRAMAS DE</span><br/><span i18n="@@pos_graduacao">PÓS-GRADUAÇÃO</span></h1>
            </div>
          </div>
        </div>
        <div class="locales-container">
          <div *ngFor="let locale of localesList">
            <a mat-icon-button title="{{locale.label}}" href="{{locale.path}}">
              <img src="{{locale.image}}" width="24"/>
            </a>
          </div>
        </div>
      </div>
    </section>
  </header>
  @if (!loadFail) {
  <main>
    <div class="container mb-2 mt-3">
      <mat-accordion id="search">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>search</mat-icon> <span i18n="@@pesquisar">Pesquisar</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="form">
            <div class="row row-cols-12">
              <div class="col-12 col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@nome_programa">Nome do programa</mat-label>
                  <mat-icon matPrefix (click)="limpar('nomeCurso')" *ngIf="form.controls.nomeCurso.getRawValue()?.length">closed</mat-icon>
                  <input matInput type="text" i18n-placeholder="@@ph_nome_programa" placeholder="Programa de pós-graduação" [formControl]="form.controls.nomeCurso" (keyup)="pesquisar()"/>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-8">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@linha_pesquisa">Linha de pesquisa</mat-label>
                  <mat-icon matPrefix (click)="limpar('linhaPesquisa')" *ngIf="form.controls.linhaPesquisa.getRawValue()?.length">closed</mat-icon>
                  <input matInput type="text" i18n-placeholder="@@ph_linha_pesquisa" placeholder="Linhas de pesquisa" [formControl]="form.controls.linhaPesquisa" [matAutocomplete]="autoLinha" (keydown.enter)="validarFiltroLinhaPesquisa()"/>
                  <mat-autocomplete autoActiveFirstOption #autoLinha="matAutocomplete">
                    <mat-option *ngFor="let linhaPesquisa of linhaPesquisaFiltered | async" (onSelectionChange)="selecionarLinhaPesquisa(linhaPesquisa)" [value]="linhaPesquisa">
                      {{ linhaPesquisa }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="row row-cols-1 row-cols-lg-3">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@area_conhecimento">Área de conhecimento</mat-label>
                  <mat-icon matPrefix (click)="limpar('area')" *ngIf="form.controls.area.getRawValue()?.length">closed</mat-icon>
                  <mat-select formControlName="area" (selectionChange)="pesquisar()">
                    <mat-option *ngFor="let area of areas" [value]="area">{{area}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@nivel">Nível</mat-label>
                  <mat-icon matPrefix (click)="limpar('nivel')" *ngIf="form.controls.nivel.getRawValue()?.length">closed</mat-icon>
                  <mat-select formControlName="nivel" (selectionChange)="pesquisar()">
                    <mat-option *ngFor="let nivel of niveis" [value]="nivel">{{nivel}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@cidade">Cidade</mat-label>
                  <mat-icon matPrefix (click)="limpar('cidade')" *ngIf="form.controls.cidade.getRawValue()?.length">closed</mat-icon>
                  <mat-select formControlName="cidade" (selectionChange)="pesquisar()">
                    <mat-option *ngFor="let cidade of cidades" [value]="cidade">{{cidade}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>Nota CAPES</mat-label>
                  <mat-icon matPrefix (click)="limpar('conceito')" *ngIf="form.controls.conceito.getRawValue()">closed</mat-icon>
                  <mat-select formControlName="conceito" (selectionChange)="pesquisar()">
                    <mat-option *ngFor="let conceito of conceitos" [value]="conceito">{{conceito}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div> -->
            </div>
            <div class="row row-cols-12">
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@disciplina">Disciplina</mat-label>
                  <mat-icon matPrefix (click)="limpar('disciplina')" *ngIf="form.controls.disciplina.getRawValue()?.length">closed</mat-icon>
                  <input matInput type="text" i18n-placeholder="@@disciplina" placeholder="Disciplina" [formControl]="form.controls.disciplina" [matAutocomplete]="autoDisciplina" (keydown.enter)="validarFiltroDisciplina()"/>
                  <mat-autocomplete autoActiveFirstOption #autoDisciplina="matAutocomplete">
                    <mat-option *ngFor="let disciplina of disciplinaFiltered | async" (onSelectionChange)="selecionarDisciplina(disciplina)" [value]="disciplina">
                      {{ disciplina }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@docente">Docente</mat-label>
                  <mat-icon matPrefix (click)="limpar('docente')" *ngIf="form.controls.docente.getRawValue()?.length">closed</mat-icon>
                  <input matInput type="text" i18n-placeholder="@@docente" placeholder="Docente" [formControl]="form.controls.docente" [matAutocomplete]="autoDocente" (keydown.enter)="validarFiltroDocente()"/>
                  <mat-autocomplete autoActiveFirstOption #autoDocente="matAutocomplete">
                    <mat-option *ngFor="let docente of docenteFiltered | async" (onSelectionChange)="selecionarDocente(docente)" [value]="docente">
                      {{ docente }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </form>
        </mat-expansion-panel>
      </mat-accordion>
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 mt-1">
        <div class="col" *ngFor="let programa of programas; index as i;">
          <div class="card shadow-sm" (click)="openDialog(programa)">
            <div class="card-programa card-icon"  [ngClass]="{
                'card-icon-1': programa.codigoCnpq === '1',
                'card-icon-2' : programa.codigoCnpq === '2',
                'card-icon-3' : programa.codigoCnpq === '3',
                'card-icon-4' : programa.codigoCnpq === '4',
                'card-icon-5' : programa.codigoCnpq === '5',
                'card-icon-6' : programa.codigoCnpq === '6',
                'card-icon-7' : programa.codigoCnpq === '7',
                'card-icon-8' : programa.codigoCnpq === '8',
                'card-icon-9' : programa.codigoCnpq === '9',
              }">
              <p class="card-programa-nome" [innerHtml]="programa.nome | programaNome"></p>
              <div class="card-curso card-curso-info">
                @if(locale === 'en') {
                  <span>{{programa.niveis.join(' and ')}}</span>
                } @else {
                  <span>{{programa.niveis.join(' e ')}}</span>
                }
              </div>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div class="pr-2">
                  <p *ngFor="let unidade of programa.unidades;">
                    {{unidade.nome}}
                    <br/><span class="card-unidade-campus">{{unidade.cidade}}</span>
                  </p>
                </div>
                <!-- <div class="card-body-right" *ngIf="programa.conceito">
                  <div class="badge rounded-pill text-bg-primary mb-2 conceito">{{programa.conceito}}</div>
                  <p class="text-small">Nota<br/>CAPES</p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="alert alert-danger mt-3 pb-3 text-center" role="alert" *ngIf="programas.length === 0 && dados.length > 0">
        <span i18n="@@nenhum_resultado">Nenhum resultado encontrado para a pesquisa.</span>
      </div>
    </div>
  </main>
  } @else {
  <main>
    <div class="container mb-2 mt-3">
      <div class="alert alert-danger mt-3 pb-3 text-center" role="alert">
        <span i18n="@@loadFail">Não foi possível carregar as informações.</span>
      </div>
    </div>
  </main>
  } 
  <footer class="mt-auto">
    <div class="container">
      <address class="mb-0">
        <a href="https://www2.unesp.br/portal#!/propg" target="_blank" aria-label="Área responsável: PROPG" title="Área responsável: PROPG - Pró-reitoria de Pós-graduação">PROPG</a>
        |
        <a href="https://www2.unesp.br/portal#!/ctinf" target="_blank" aria-label="Proprietário: CTINF" title="Proprietário: CTINF - Coordenadoria de Tecnlogia da Informação">CTINF</a>
        |
        <a href="https://www2.unesp.br/portal#!/gtdsi" target="_blank" aria-label="Desenvolvido por: GTDSI" title="Desenvolvido por: GTDSI - Grupo Técnico de Desenvolvimento de Sistemas Institucionais">GTDSI</a>
      </address>
    </div>
  </footer>
</div>